import { css } from 'styled-components';

// put this in a css prop on your component
// <Example css={minMd} />

export const minMd = css`
  @media all and (max-width: ${({ theme }) => theme.breakingpoints.md}) {
    display: none;
  }
`;

export const maxMd = css`
  @media all and (min-width: ${({ theme }) => theme.breakingpoints.md}) {
    display: none;
  }
`;

export const hideOnMd = css`
  @media all and (min-width: ${({ theme }) => theme.breakingpoints.md}) and (max-width: ${({ theme }) => theme.breakingpoints.lg}) {
    display: none;
  }
`;

export const showOnMd = css`
  @media all and (max-width: ${({ theme }) => theme.breakingpoints.md}) {
    display: none;
  }
  @media all and (min-width: ${({ theme }) => theme.breakingpoints.lg}) {
    display: none;
  }
`;

export const maxLg = css`
  @media all and (min-width: ${({ theme }) => theme.breakingpoints.lg}) {
    display: none;
  }
`;

export const minLg = css`
  @media all and (max-width: ${({ theme }) => theme.breakingpoints.lg}) {
    display: none;
  }
`;

export const maxBreakpoint = (breakpoint) => css`
  @media all and (min-width: ${({ theme }) => theme.breakingpoints[breakpoint]}) {
    display: none;
  }
`;
export const minBreakpoint = (breakpoint) => css`
  @media all and (max-width: ${({ theme }) => theme.breakingpoints[breakpoint]}) {
    display: none;
  }
`;
